export enum InquiryType {
	Wedding = "Wedding",
	CustomCake = "CustomCake",
}
